export enum ProjectServiceId {
    Account = 'account',
    Avatars = 'avatars',
    Databases = 'databases',
    Tablesdb = 'tablesdb',
    Locale = 'locale',
    Health = 'health',
    Project = 'project',
    Storage = 'storage',
    Teams = 'teams',
    Users = 'users',
    Vcs = 'vcs',
    Sites = 'sites',
    Functions = 'functions',
    Proxy = 'proxy',
    Graphql = 'graphql',
    Migrations = 'migrations',
    Messaging = 'messaging',
    Advisor = 'advisor',
    Oauth2 = 'oauth2',
}
